import { Component, Input } from "@angular/core";
import { DistributionRuleModel } from "../../../models/cart/distribution-rule.model";

@Component({
    selector: "pcg-ng-depositors-list",
    template: require('./depositors-list.component.html')
})
export class DepositorsListComponent {
    @Input() public distributionRules: Array<DistributionRuleModel>;
}
